import axios from 'axios';
export var login = function (api, username, password) {
    var headers = {
        'Content-Type': 'application/json',
    };
    return axios
        .post(api + "/api/auth-business-users", { username: username, password: password }, { headers: headers });
};
export var loginWithAuthorizationCode = function (api, code) {
    var headers = {
        'Content-Type': 'application/json',
    };
    return axios
        .post(api + "/api/auth-business-users", { code: code }, { headers: headers });
};
export var startMfa = function (api, mfaPendingCredential, mfaEnrollmentId, recaptchaToken) {
    var headers = {
        'Content-Type': 'application/json',
    };
    return axios
        .post(api + "/api/auth-start-mfa-business-users", { mfaPendingCredential: mfaPendingCredential, mfaEnrollmentId: mfaEnrollmentId, recaptchaToken: recaptchaToken }, { headers: headers });
};
export var finalizeMfa = function (api, mfaPendingCredential, sessionInfo, verificationCode) {
    var headers = {
        'Content-Type': 'application/json',
    };
    return axios
        .post(api + "/api/auth-finalize-mfa-business-users", { mfaPendingCredential: mfaPendingCredential, sessionInfo: sessionInfo, verificationCode: verificationCode }, { headers: headers });
};
export var refresh = function (api, refreshToken) {
    var headers = {
        'Content-Type': 'application/json',
    };
    return axios
        .post(api + "/api/auth-business-users/refresh", { refreshToken: refreshToken }, { headers: headers });
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/ecommscript-integrationappauth/dist/Api/authBusinessUsersClient.js
// module id = 1272
// module chunks = 0